import { useQuery, useMutation } from '@tanstack/react-query';
import {
  GET_QUESTION_ENDPOINT,
  GET_QUESTION_STORE_ENDPOINT,
} from '@/app/_libs/utils/constants/endpoints';

async function getProductQuestions(id) {
  const res = await fetch(`${GET_QUESTION_ENDPOINT}/${id}`, {
    method: 'get',
    headers: new Headers({
      Accept: 'application/json',
    }),
  });

  const questions = await res.json();
  return questions;
}
async function updateQuestion({ productId, question, token }) {
  var formData = new FormData();
  formData.append('product_id', productId);
  formData.append('question', question);
  const res = await fetch(`${GET_QUESTION_STORE_ENDPOINT}/store`, {
    method: 'POST',
    body: formData,
    headers: new Headers({
      Authorization: 'Bearer ' + token,
      Accept: 'application/json',
    }),
  });
  const updateQuestion = await res.json();
  return updateQuestion;
}

const useQuestions = (id) => {
  const fallback = null;
  const { data: questions = fallback } = useQuery({
    queryKey: ['questions', id],
    queryFn: () => getProductQuestions(id),
  });
  return { questions };
};
const useUpdateQuestion = () => {
  return useMutation({
    mutationFn: (productId, question, token) =>
      updateQuestion(productId, question, token),
  });
};
export { useQuestions, useUpdateQuestion };
